import { render, staticRenderFns } from "./PopupView.vue?vue&type=template&id=e51b552a&scoped=true"
import script from "./PopupView.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PopupView.vue?vue&type=style&index=0&id=e51b552a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51b552a",
  null
  
)

export default component.exports